
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/company/topmessage",
      function () {
        return require("private-next-pages/en/company/topmessage.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/company/topmessage"])
      });
    }
  